import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TrashcanIcon from '@wix/da-ds/pkg/Icons/24x24/Trashcan';
import { PremiumTrash } from '@wix/da-ds/pkg/Icons/Confirmations';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { DeviationTypes } from '../../../types/deviation';
import TierCreatorReduxModule from '../../../Tier/redux/creator/ModuleLoadable';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ConfirmationModal from '../../../Popup/ConfirmationModal';
import { deviationTypeToTranslationKey, getDeviationType, getDeviationResourceType, } from '../../../DeviationViews/_helpers';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import ActionBarEditButton from '../../_partials/items/ActionBarEditButton';
export var DeleteButton = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick;
    var t = useTranslation().t;
    var _b = useState(false), isShowingConfirmation = _b[0], setShowingConfirmation = _b[1];
    var logBiEvent = useBiLogger();
    var type = getDeviationType(deviation);
    var typeName = t(deviationTypeToTranslationKey(type));
    return (React.createElement(React.Fragment, null,
        React.createElement(TierCreatorReduxModule, null),
        React.createElement(ActionBarItemWrapper, { tooltip: t('actionbar.delete') },
            React.createElement(ActionBarEditButton, { onClick: function () {
                    if (type === DeviationTypes.TIER) {
                        onClick({ deviation: deviation });
                    }
                    else {
                        setShowingConfirmation(true);
                    }
                }, biData: {
                    evid: BiEventType.DEVIATION_DELETE_CLICK,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                } },
                React.createElement(ActionBarIcon, { icon: TrashcanIcon }))),
        React.createElement(ConfirmationModal, { isOpen: isShowingConfirmation, title: t('actionbar.delete.confirm', { type: typeName }), text: t('actionbar.delete.cantGoBack'), confirmBtnLabel: t('actionbar.delete'), cancelBtnLabel: t('popup.cancel'), icon: React.createElement(PremiumTrash, null), confirmBtnType: "danger", onConfirm: function () {
                logBiEvent({
                    evid: BiEventType.DELETE_DEVIATION_CONFIRM_CLICK,
                    itemid: deviation.deviationId,
                    typeid: getDeviationResourceType(deviation),
                });
                setShowingConfirmation(false);
                onClick({ deviation: deviation, shouldRedirect: true });
            }, onCancel: function () { return setShowingConfirmation(false); } })));
};
DeleteButton.displayName = 'DeleteButton';
export default DeleteButton;
//# sourceMappingURL=DeleteButton.js.map